import React from "react";
import ReactDOM from "react-dom";
import App from "./containers/App";

/** This is the main entry point of ReactJS */
ReactDOM.render(<App />, document.getElementById("root"));
